module.exports = __webpack_public_path__ + "static/media/Headshot_Square.ad2d9028.png";